import { isMobileClient } from './os';

export const MOBILE_REDIRECT_APP_URL_KEY = 'app.mobile.redirect_url';

/** Matches common `sm` breakpoint; tablets and split-view stay on web. */
const SMARTPHONE_VIEWPORT_MAX_WIDTH_PX = 768;

function isSmartphoneViewport(): boolean {
  return (
    typeof window !== 'undefined' &&
    window.innerWidth < SMARTPHONE_VIEWPORT_MAX_WIDTH_PX
  );
}

export function redirectMobileToNativeAppIfConfigured(config: {
  features?: Record<string, unknown>;
}): boolean {
  const raw = config?.features?.[MOBILE_REDIRECT_APP_URL_KEY];
  if (typeof raw !== 'string' || raw.trim() === '') {
    return false;
  }
  if (!isMobileClient() || !isSmartphoneViewport()) {
    return false;
  }
  try {
    const next = new URL(raw, window.location.href);
    if (next.href === window.location.href) {
      return false;
    }
  } catch {
    return false;
  }
  window.location.replace(raw);
  return true;
}
